import api from '../../../configs/instanceApi';

export const sendTerms = (ecIdentity, terms, recaptchaToken = '') => {
  const url = `/accreditation-quotations/quotations/${ecIdentity}/terms`;
  const config = {
    headers: {}
  };

  if (recaptchaToken) {
    config.headers['X-Recaptcha-Token'] = recaptchaToken;
  }

  return api.patch(url, terms, config);
};
